import React from 'react'
import styles from '@bt-react/styles'
import { Label as ReactstrapLabel, LabelProps as ReactstrapLabelProps } from 'reactstrap'

export interface LabelProps extends Partial<ReactstrapLabelProps> {
  dataBdd?: string
  className?: string
}

export default class Label extends React.Component<LabelProps> {

  render () {

    if (!this.props.children) return null

    return (
      <ReactstrapLabel
        data-bdd={this.props.dataBdd || 'label'}
        cssModule={styles}
        for={this.props.for}
        check={this.props.check}
        className={this.props.className}
      >{this.props.children}</ReactstrapLabel>
    )

  }

}
